<template>
	<div class="section-galler mt-10 pt-10">
		<p class="text-h5 my-5 text-center primary--text font-weight-bold">Фотогалерея</p>

		<v-slide-group show-arrows>
			<v-slide-item v-for="(Item, index) in Previews" :key="index">
				<v-dialog v-model="Active[index]" scrollable>
					<template v-slot:activator="{ on, attrs }">
						<v-img v-on="on" v-bind="attrs" :src="Item" max-width="256" class="mx-1" />
					</template>
					<v-card style="overflow: hidden">
						<v-img :src="Items[currentIndex]" height="100%" contain />
						<v-btn @click="$set(Active, index, false)" color="primary" small absolute top right fab class="mt-8">
							<v-icon>mdi-close</v-icon>
						</v-btn>

						<v-btn 
							v-if="currentIndex > 0"
							@click="currentIndex--" 
							color="primary" 
							absolute 
							top 
							left 
							fab
							:x-large="!$vuetify.breakpoint.xs"
							:small="$vuetify.breakpoint.xs"
							text
							outlined
							:class="$vuetify.breakpoint.xs ? 'ml-n1' : 'ml-4'"
							elevation="0"
							style="top: 50%; transform: translateY(-50%);"
						>
							<v-icon>mdi-chevron-left</v-icon>
						</v-btn>
						
						<!-- Кнопка следующего изображения -->
						<v-btn 
							v-if="currentIndex < Items.length - 1"
							@click="currentIndex++" 
							color="primary" 
							absolute 
							top 
							right 
							fab
							:x-large="!$vuetify.breakpoint.xs"
							:small="$vuetify.breakpoint.xs"
							text
							outlined
							elevation="0"
							:class="$vuetify.breakpoint.xs ? 'mr-n1' : 'mr-12'"
							style="top: 50%; transform: translateY(-50%);"
						>
							<v-icon>mdi-chevron-right</v-icon>
						</v-btn>
					</v-card>
				</v-dialog>
			</v-slide-item>
		</v-slide-group>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionGalleryRedMachine',
	data: () => ({
		Active: [] as Array<boolean>,
		currentIndex: 0,
		Items: [
			require('./../assets/images/gallery/2025/red-machine/Red_machine_01.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_02.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_03.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_04.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_05.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_06.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_07.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_08.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_09.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_010.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_011.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_012.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_013.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_014.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_015.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_016.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_017.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_018.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_019.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_020.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_021.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_022.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_023.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_024.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_025.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_026.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_027.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_028.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_029.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_030.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_031.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_032.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_033.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_034.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_035.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_036.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_037.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_038.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_039.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_040.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_041.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_042.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_043.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_044.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_045.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_046.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_047.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_048.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_049.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_050.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_051.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_052.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_053.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_054.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_055.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_056.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_057.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_058.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_059.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_060.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_061.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_062.jpg'),
			require('./../assets/images/gallery/2025/red-machine/Red_machine_063.jpg')
		],
		Previews: [
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_01.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_02.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_03.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_04.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_05.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_06.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_07.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_08.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_09.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_010.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_011.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_012.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_013.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_014.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_015.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_016.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_017.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_018.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_019.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_020.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_021.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_022.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_023.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_024.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_025.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_026.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_027.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_028.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_029.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_030.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_031.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_032.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_033.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_034.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_035.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_036.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_037.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_038.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_039.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_040.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_041.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_042.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_043.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_044.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_045.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_046.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_047.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_048.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_049.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_050.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_051.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_052.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_053.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_054.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_055.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_056.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_057.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_058.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_059.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_060.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_061.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_062.jpg'),
			require('./../assets/images/gallery/2025/red-machine/1x1/Red_machine_063.jpg')			
		],
	}),
	watch: {
		Active: {
			handler(newVal) {
				// Когда открывается диалог, устанавливаем currentIndex в индекс открытого изображения
				const openIndex = newVal.findIndex((item: any) => item === true);
				if (openIndex !== -1) {
					this.currentIndex = openIndex;
				}
			},
			deep: true
		}
	}
});
</script>
